<template>
  <div>
    Williams %R over {{ rule.config.days }} days,
    {{
      rule.config.above_below == 'below'
        ? 'oversold (<= -' + rule.config.threshold + ')'
        : 'overbought (>= -' + rule.config.threshold + ')'
    }}
  </div>
</template>

<script>
export default {
  props: {
    rule: { type: Object, required: true }
  }
}
</script>
